import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constant } from 'src/app/constant/constant';
import { ConfigService } from 'src/app/services/config.service';
import { LeadActivityService } from 'src/app/services/lead-activity.service';
import { DooctiCallComponent } from './doocti-call/doocti-call.component';
import { CrmsettingsService } from 'src/app/services/crmsettings.service';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-call-list',
  templateUrl: './call-list.component.html',
  styleUrls: ['./call-list.component.scss']
})
export class CallListComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';


  url = '';


  firstFormGroup: UntypedFormGroup;
  data: any;
  text: string;
  LeadCallOject: any;
  storeName: any;


  constructor(
    private ecryptService: EcryptServiceService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data,
    private _formBuilder: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<CallListComponent>,
    private leadActivityService: LeadActivityService,
    private configService: ConfigService,
    private crmsettingsService: CrmsettingsService, private router: Router
  ) {

    this.data = data;
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }


  ngOnInit(): void {

    this.initActivity();
    this.text = "Ok";
    this.getConfigData();
    this.getAllCrmData();

    this.LeadCallOject = this.data.data;


  }


  whatsAppCustomUrl: any = 0;
  whatAppUrl: any;

  getAllCrmData() {

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        if (data != null) {

          this.whatsAppCustomUrl = data['whatsAppCustomUrl'];

          this.whatAppUrl = data['whatAppUrl'];

          localStorage.setItem(Constant.LEAD_POPUP, data['enableInCallNotification']);
        } else {

          this.whatsAppCustomUrl = 0;

        }


      }
      catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }
  }

  initActivity() {
    this.firstFormGroup = this._formBuilder.group({
      phoneCallType: ["0"],
    });
  }

  editlead(call: any) {
    this.firstFormGroup = this._formBuilder.group({
      phoneCallType: call.phoneCallType,
    })

  }



  phoneCallType: any = [
    { value: "0", viewValue: "Exotel" },
    { value: "1", viewValue: "Phone" },
    { value: "2", viewValue: "Whatsapp" },
    { value: "3", viewValue: "Doocti" },
  ]

  phoneCallTypenew: any = [
    { value: "0", viewValue: "Exotel" },
    { value: "1", viewValue: "Phone" },
    { value: "2", viewValue: "Whatsapp" },
  ]


  submitType() {
    this.dialogRef.close({ event: 'add', })
  }


  close() {
    this.dialogRef.close({ event: 'close' })
  }

  getConfigData() {
    const encryptedData = localStorage.getItem('configSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);
        this.storeName = data['storeName'];
      }

      catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }
  }

  submit() {

    if (this.text == 'Ok') {
      if (this.firstFormGroup.value.phoneCallType == 0) {
        this.leadActivityService.makeCall(this.LeadCallOject).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });
              this.dialog.closeAll();
            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.dialog.closeAll();
          },
          error => {

          });
      } else if (this.firstFormGroup.value.phoneCallType == 2) {

        if (this.whatsAppCustomUrl == 0) {
          let message = `Hi ${this.LeadCallOject.name}, I'm from ${this.storeName}.\n`;
          let url = `https://api.whatsapp.com/send?phone= ${encodeURIComponent(this.LeadCallOject.phoneNumber)}&text=${encodeURIComponent(message)}`;
          window.open(url, '_blank');
          this.dialog.closeAll();
        } else {
          let url = this.whatAppUrl;
          window.open(url, '_blank');
        }

      } else if (this.firstFormGroup.value.phoneCallType == 3) {

        this.dialog.closeAll();
        if (window.innerWidth > 768) {

          let dialogRef = this.dialog.open(DooctiCallComponent, {

            data: { data: this.LeadCallOject }
          });

          dialogRef.disableClose = true;
          dialogRef.afterClosed().subscribe(result => {


          });

        }
        else {
          let dialogRef = this.dialog.open(DooctiCallComponent, {
            minWidth: '100vw', height: '100vh',
            data: { data: this.LeadCallOject.phoneNumber, }
          });

          dialogRef.disableClose = true;
          dialogRef.afterClosed().subscribe(result => {

          });
        }

      }
      //  else if (this.firstFormGroup.value.phoneCallType == 1) {

      //   let phonenumber = "tel:+" + this.LeadCallOject.phoneNumber;

      //   window.location.href = phonenumber;

      //   this.dialog.closeAll();
      // }

      if (this.firstFormGroup.value.phoneCallType == 1) {
        let phonenumber;

        if (this.LeadCallOject.phoneNumber.includes('+')) {
          phonenumber = "tel:" + this.LeadCallOject.phoneNumber;
        } else {
          phonenumber = "tel:+" + this.LeadCallOject.phoneNumber;
        }

        window.location.href = phonenumber;

        console.log(phonenumber);


        this.dialog.closeAll();
      }

    }
    else {

    }
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
